import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

//import Home from '@/pages/index/home'
import Home from '@/pages/main/main'//新主页
import Login from '@/pages/login/loginmain' //'@/pages/login/loginindex'
import Desktop from '@/pages/index/desktop'
import Test from '@/pages/test/index1'
import setmode from '@/pages/index/setmode'
import payewm from '@/pages/cw/chargeewm'
import gettax from '@/pages/index/gettaxid'
import onlinesign from '@/pages/sign/onlinesign'
import invoice from '@/pages/invoice/createinvoice'
import immsg from '@/pages/msg/IMmsg'
import payonline from '@/pages/cw/payonline'
import paydone from '@/pages/paydone'//支付操作完成，比如支付取消，支付成功
import testpage from '@/pages/test/HomeView'
//import reportbi from '@/pages/BI/report_bi'
const routes = [{
  path: '/',
  component: Home,
  redirect: '/index',
  mata:{
	  title:'后台管理系统'
  },
  children: [
	  {
    path: '/index',
    component: Desktop
  }
  ]
}, {
  path: '/login',
  component: Login,
  mata:{
  	  title:'登录'
  },
}, {
  path: '/desktop',
  component: Desktop
},
{
    path: '/pay',
    component: payewm
  }, 
{
    path: '/GetTax',
    component: gettax
  }, 
, 
{
    path: '/setmode',
    component: setmode
  },
{
    path: '/Test',
    component: Test
  },	
  {
    path: '/onlinesign',
    component: onlinesign
  },
  {
	path: '/invoice',
	component: invoice,
	name:'param'
  },
  {
	path: '/immsg',
	component: immsg,
	name:'param'
  },
  {
  	path: '/payline',
  	component: payonline,
  	name:'param'
  },
    {
  	path: '/paydone',
  	component: paydone,
	name:'param'
  },
  {
  	path: '/testpage',
  	component: testpage,
	name:'param'
  },
  // ,
  // {
  // 	path: '/report',
  // 	component: reportbi,
  // 	name:'param'
  // }
  ]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes
})

router.onError((err) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = err.message.match(pattern);
  if (isChunkLoadFailed) {
    let chunkBool = sessionStorage.getItem('chunkError');
    let nowTimes = Date.now();
    if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) {//路由跳转报错,href手动跳转
      sessionStorage.setItem('chunkError', 'reload');
      const targetPath = routers.history.pending.fullPath;
      window.location.href = window.location.origin + targetPath;
    }else if(chunkBool === 'reload'){ //手动跳转后依然报错,强制刷新
	console.log('手动跳转后依然报错,强制刷新');
      sessionStorage.setItem('chunkError', Date.now());
      window.location.reload(true);
    }
  }
})
export default router